import React from 'react';

const VisibilityIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6666 8.05797C14.6666 8.05797 11.6811 12.1159 7.99992 12.1159C4.31876 12.1159 1.33325 8.05797 1.33325 8.05797C1.33325 8.05797 4.31876 4 7.99992 4C11.6811 4 14.6666 8.05797 14.6666 8.05797Z"
        stroke="#C1C3C6"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M7.99993 10.087C9.12051 10.087 10.0289 9.17855 10.0289 8.05798C10.0289 6.9374 9.12051 6.02899 7.99993 6.02899C6.87936 6.02899 5.97095 6.9374 5.97095 8.05798C5.97095 9.17855 6.87936 10.087 7.99993 10.087Z"
        stroke="#C1C3C6"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default VisibilityIcon;
